<template>
    <div id="grid">
        <!-- Visualização da Lista -->
        <div id="list" v-show="!showForm">
            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                :filter-button="true"
                :filter-month="true"
                :month-filter="monthFilter"
                :adv-filters-object="filtroAvancado"
                :field-month="'data'"
                single-entity="Pedido de Compra"
                plural-entity="Pedidos de Compra"
                @search="search"
                @filter="handleChangeFilter"
                @advancedfilter="handleChangeAdvancedFilter"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pelo número do pedido ou nome do fornecedor">
            </bar-list>

            <div class="default-container">
                <alert v-if="compraList.length == 0" type="norecord"></alert>

                <div class="mainbox" v-for="item in compraList" :key="item.codcompra">
                    <div class="box">
                        <div class="row">
                            <!-- Informações do Pedido -->
                            <div class="col-md-4 col-12">
                                <span class="lbl-title-produto">#{{ item.npedido }}</span><br>
                                <span class="data-list"><i class="fa fa-calendar mr-1"></i> {{ item.data | formatData }}</span>
                            </div>
                            <!-- Fornecedor e Total -->
                            <div class="col-md-4 col-12">
                                <label class="lbl-list">Fornecedor</label><br>
                                <span class="data-list">{{ item.nome_fornecedor }}</span><br>
                                <span class="data-list">R$ <strong>{{ item.totpedido | formatValue(2) }}</strong></span>
                            </div>
                            <!-- Status -->
                            <div class="col-md-2 col-12 text-center">
                                <span class="badge" :class="statusClass(item.status)">
                                    {{ statusLabel(item.status) }}
                                </span>
                            </div>
                            <!-- Ações -->
                            <div class="col-md-2 col-12">
                                <bar-grid
                                    :options="{barDefault: true, btnView: true, btnEdit: item.status == 'A'}"
                                    :moreActions="[{action: 1, label: 'Imprimir', icon: 'fa-print'}]"
                                    @edit="handleEdit(item.codcompra)"
                                    @view="handleEdit(item.codcompra, true)"
                                    @action="handleAction($event, item.codcompra)">
                                </bar-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Formulário de Manutenção -->
        <compra-form v-if="showForm" :crud="crud" :id="selectedId" @closeform="closeForm"></compra-form>

        <!-- Impressão -->
        <div style="display: none">
            <pedido-compra-impressao ref="impressao" v-if="showImpressao" :index="codcompraImpressao" @close="handleClosePrint"/>
        </div>
    </div>
</template>

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import CompraForm from './compra-form'
import PedidoCompraImpressao from './pedido-compra-impressao.vue'
import { SysVars } from '../main'
import { formatDate, formatValue } from '../shared/utils'
import { apiDateORDS } from '../shared/api-functions'

export default {
    components: {
        BarList, BarGrid, CompraForm, PedidoCompraImpressao
    },
    data() {
        return {
            showForm: false,
            crud: '',
            selectedId: '',
            filter: '',
            monthFilter: {},
            offset: false,
            metadata: this.$store.getters.getEntities.metadata,
            showImpressao: false,
            filtroAvancado: {
              periodo: {
                label: 'Data da compra',
                varios: false,
                data_inicio: null,
                data_termino: null,
              },

              filtros: [
                { nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] },
              ],

            },
            filterList: [], //lista de filtros aplicados que são exibidos em tela

            codcompraImpressao: null
        }
    },
    computed: {
        compraList() {
            return this.$store.getters.getCompraList || []
        },
        nextPage() {
            return this.$store.getters.getNextPage
        }
    },
    methods: {
        handleChangeFilter(url) {
            this.filter = url
            this.loadData()
        },
        handleChangeAdvancedFilter(filtro) {
          var arrUrl = []

          var urlFilter = ''
          if (filtro.periodos && filtro.periodos.length > 0) {
            if (filtro.periodos[0].startDate && filtro.periodos[0].endDate) {
              urlFilter = '{"data":{"$between":[{"$date":"' + apiDateORDS(filtro.periodos[0].startDate) + '"},{"$date":"' + apiDateORDS(filtro.periodos[0].endDate, true) + '"}]}}'
              arrUrl.push(urlFilter)
            }
          }


          urlFilter = ''
          if (filtro.clientefornecedor && filtro.clientefornecedor.length > 0) {
            for (let x = 0; x < filtro.clientefornecedor.length; x++) {
              if (urlFilter != '') {
                urlFilter = urlFilter + ','
              }
              urlFilter = urlFilter + '{"codpart":{"$eq":"' + filtro.clientefornecedor[x] + '"}}'
            }
            if (urlFilter != '') {
              urlFilter = '{"$or":[' + urlFilter + ']}'
              arrUrl.push(urlFilter)
            }

          }

          let url = ''
          for (let i = 0; i < arrUrl.length; i++) {
            if (i != 0) {
              url = url + ','
            }
            url = url + arrUrl[i]
          }
          if (url != '')
            url = '{"$and":[' + url + ']}'


          console.log(filtro)
          console.log(url)
          this.filter = url
          this.loadData()
        },



        async loadData() {
            let params = { filter: this.filter }
            if (this.offset) {
                params.offset = this.nextPage
            }
            await this.$store.dispatch('loadCompraList', params)
            this.offset = false
        },
        handleNew() {
            this.selectedId = ''
            this.crud = SysVars.crudI
            this.showForm = true
        },
        handleEdit(id, view = false) {
            this.selectedId = id
            this.crud = view ? SysVars.crudView : SysVars.crudU
            this.showForm = true
        },
        handleAction(act, id) {
            if (act == 1) {
                this.onImprimir(id)
            }
        },
        closeForm() {
            this.showForm = false
            this.loadData()
        },
        search(value) {
            const str = value.toUpperCase()
            this.filter = JSON.stringify({
                "$or": [
                    { "npedido": { "$like": "%25" + str + "%25" } },
                    { "nome_fornecedor": { "$like": "%25" + str + "%25" } }
                ]
            })
            this.loadData()
        },
        scroll() {
            window.onscroll = () => {
                if (this.showForm || this.nextPage == 0 || this.offset) return
                let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= (document.documentElement.offsetHeight - 2)
                if (bottomOfWindow) {
                    this.offset = true
                    this.loadData()
                }
            }
        },
        statusLabel(s) {
            const labels = { 'A': 'Aberto', 'F': 'Finalizado', 'C': 'Cancelado' }
            return labels[s] || s
        },
        statusClass(s) {
            const classes = { 'A': 'badge-blue', 'F': 'badge-green', 'C': 'badge-red' }
            return classes[s] || 'badge-gray'
        },
        onImprimir(id) {
            this.codcompraImpressao = id
            this.showImpressao = true
            this.$nextTick(function () {
                this.$refs.impressao.print()
            })
        },
        handleClosePrint() {
            this.showImpressao = false
        }
    },
    mounted() {
      this.filter = this.monthFilter.url //carrega as notas do mes corrente
      this.loadData()
      this.scroll()
    },
    created() {
        this.loadData()
    },
    destroyed() {
        window.onscroll = null
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/forms/compra-list.vue